import { Resource } from "../resource/resource.model";
import { PreferenceOption } from "../preference-option/preference-option.model";

export class PreferenceCatalog extends Resource {
    name: string;
    code: string;
    dependsOn: string;
    dependsOnLogic: string;
    status: string;
    options: PreferenceOption[];
    tenantId: string;
}
